import Base64 from './../../static/vendor/base64/base64'

export default function (title, note) {
  let base64 = new Base64();
  let { userInfo , objApi } = this.$store.getters;
  let userString = userInfo ? `uid=${userInfo.id}&name=${userInfo.name}&email=${userInfo.email}&mobile=${userInfo.mobile}&roleNames=${userInfo.roleNames}&orgName=${userInfo.orgName}&` : '';
  let data = base64.encode(`${userString}url=${window.location.href}&title=${title}&note=${note}`);
  window.open(`${objApi.SERVICE_API}index.html?${data}`);
}



// WEBPACK FOOTER //
// ./src/utils/open-service.js